import ClickOutside from '@lib/click-outside'
import clsx from 'clsx'
import { FC, useState } from 'react'
import { MdChevronRight } from 'react-icons/md'
import { UrlSorting, getSortingOptions } from './sorting'

type SortingDropdownProps = {
  optionToggle: (field: any, direction) => void
  chosen: UrlSorting | null
  isMobile?: boolean
}

const SortingDropdown: FC<SortingDropdownProps> = ({
  chosen,
  optionToggle,
  isMobile,
}) => {
  const options = getSortingOptions(chosen)
  const [open, setOpen] = useState<boolean>(false)
  return (
    <ClickOutside active={true} onClick={() => setOpen(false)}>
      <div
        className={clsx('relative text-left inline-block', {
          ['mr-2']: isMobile,
        })}
      >
        <button
          onClick={() => setOpen(!open)}
          className={clsx('flex justify-center items-center paragraphOne')}
        >
          {chosen
            ? options
                .find(
                  (x) =>
                    x.field == chosen.field && x.direction == chosen.direction,
                )
                ?.label.toUpperCase()
            : 'Sort by'}
          <MdChevronRight
            className={clsx('transition-transform ml-1', {
              'rotate-90': !open,
              '-rotate-90': open,
            })}
          />
        </button>
        <ul
          className={clsx(
            'absolute mt-2 w-56 rounded-sm shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none z-10 origin-top-right right-0',
            { '!hidden': !open },
          )}
        >
          {options?.map((option, index) => (
            <li key={index}>
              <button
                className={clsx(
                  'flex lock px-4 py-2 text-sm text-gray-700 hover:bg-[#f8f7f7] cursor-pointer w-full paragraphOne',
                  { 'bg-[#f8f7f7]': option.chosen },
                )}
                type="button"
                onClick={() => optionToggle(option.field, option.direction)}
              >
                {option.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </ClickOutside>
  )
}

export default SortingDropdown
